export const CREATE_PRODUCTION = 'CREATE_PRODUCTION';
export const GET_PRODUCTIONS = 'GET_PRODUCTIONS';
export const PRODUCTION_REQUEST = 'PRODUCTION_REQUEST';
export const UPDATE_PRODUCTION = 'UPDATE_PRODUCTION';
export const DELETE_PRODUCTION = 'DELETE_PRODUCTION';
export const PRODUCTION_REQUEST_FAILURE = 'PRODUCTION_REQUEST_FAILURE';
export const GET_PRODUCTION_PAGE = 'GET_PRODUCTION_PAGE';
export const PRODUCTION_REQUEST_SUCCESS = 'PRODUCTION_REQUEST_SUCCESS';